window.addEventListener('load', (event) => {
    console.info(event.type);
});

document.addEventListener('readystatechange', (event) => {
    console.info(`${event.type}: ${document.readyState}`);
});

document.addEventListener('DOMContentLoaded', (event) => {
    console.info(event.type);

    //global lightbox init
    /* https://github.com/biati-digital/glightbox */
    const lightbox = GLightbox();
    /* class="glightbox" */

});

//global back button
function history_back(path){
    if (document.referrer.includes(cyclone3.domain)) {
        history.back();
    }
    else {
        window.location.href = cyclone3.domain + path;
    }
};

//global btn loading
const btnLoading = {
    spinner: `<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span><span class="visually-hidden">Loading...</span>`,
    content: '',
    width: '',
    add: function(btn){
        btnLoading.content = btn.innerHTML;
        btnLoading.width =  btn.style.width;
        console.log(btn.offsetWidth);
        btn.style.width = btn.offsetWidth + 'px';
        btn.innerHTML = btnLoading.spinner;  
        btn.disabled = true;
    },
    rem: function(btn){        
        btn.style.width = btnLoading.width;
        btn.innerHTML = btnLoading.content;  
        btn.disabled = false;
    }
};